/* eslint-disable react/display-name */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ReactSelect, { components, createFilter } from "react-select";
import ReactSelectCreatable from "react-select/creatable";
import { PropTypes } from "prop-types";
import { FormLabel, Spinner } from "@chakra-ui/react";
import { FixedSizeList as List } from "react-window";
import "../style.scss";
import Info from "./Info";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ isError, noMargin }) => (isError ? "2rem" : noMargin ? "0" : ".75rem")};

  label {
    margin-left: 4px;
    margin-bottom: 4px;
    font-size: 0.8125rem;
  }

  .css-1u9des2-indicatorSeparator {
    height: 23px;
  }

  .error {
    color: #ff0000;
    font-size: 12px;
    margin-left: 4px;
    position: absolute;
    bottom: -20px;
    left: 0.5rem;
  }

  .box-select {
    position: relative;

    .icon-right {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      position: absolute;
      right: 20px;
      top: 25px;
      transform: translateY(-50%);
      pointer-events: none;
      z-index: 1;
    }

    .icon-left {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 20px;
      top: 25px;
      transform: translateY(-50%);
      pointer-events: none;
      z-index: 1;
    }

    select {
      border-radius: 8px;
      border: 1px solid #d9d9d9;
      height: 35px;
      width: 100%;
      appearance: none;
      transition: 0.2s ease-in-out;
      padding-left: 8px;
      padding-right: 8px;

      &:focus,
      &:active {
        outline: 0;
      }
    }
    .error .async-select__control {
      border-radius: 23px;
      border: 1px solid #d9d9;
    }
    .spacing-control {
      .async-select__indicators {
        position: absolute;
        right: 10px;
        top: 0;
      }
    }
    .async-select {
      font-size: 16px !important;
      &__control {
        border-radius: 8px;
        border: ${({ isError }) => (isError ? "2px solid #E53E3E" : "1px solid #d9d9d9")};
        height: ${({ isError }) => (isError ? "42px" : "40px")};
        width: 100%;
        appearance: none;
        transition: 0.2s ease-in-out;
        padding: 6px 16px 0 16px;
        height: 50px;
        display: flex;
      }

      &__value-container--has-value {
        padding: 0 38px 0 0;
      }
      &__input-container {
        font-size: 16px !important;
      }
      &__value-container {
        .async-select__input {
          font-size: 16px !important;
        }
      }

      &__indicators {
        > *&:not(:first-child) {
          display: none;
        }
      }

      &__dropdown-indicator {
        opacity: 0;
      }

      &__menu {
        z-index: 70;
      }

      &__single-value,
      &__option,
      &__menu-notice,
      &__placeholder {
        font-size: ${({ centerBlueText }) => (centerBlueText ? "20px" : "0.8125rem")};
        padding-left: ${({ centerBlueText }) => (centerBlueText ? "3rem" : "")};
        line-height: 2rem;
      }
    }
  }
`;

const customStyles = (leftIcon, centerBlueText) => ({
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "inherit" : "#192E49",
    backgroundColor: state.isSelected ? "#fff" : "inherit",
    "&:hover": {
      backgroundColor: state.isSelected ? "#192E49" : "rgb(222, 235, 255)",
      color: state.isSelected ? "#fff" : "#192E49",
    },
  }),
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#9eae9e",
    minHeight: "30px",
    height: "30px",
    boxShadow: state.isFocused ? null : null,
    fontSize: centerBlueText ? "25px" : "16px",
    paddingLeft: leftIcon ? "35px" : "",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    paddingLeft: leftIcon ? "35px" : "",
    textAlign: centerBlueText ? "center" : "left",
    color: centerBlueText ? "#01054C" : "inherit",
    width: "100%",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    overflow: "hidden",
    maxWidth: "100%",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "30px",
  }),
  placeholder: (provided) => ({
    ...provided,
    paddingLeft: leftIcon ? "30px" : "",
  }),
  input: (provided) => ({
    ...provided,
    paddingLeft: leftIcon ? "30px" : "",
  }),
});

const OPTION_HEIGHT = 40;
const ROWS = 6;

const MenuList = ({ options, children, getValue }) => {
  const [value] = getValue();
  const initialOffset =
    options.indexOf(value) !== -1
      ? Array.isArray(children) && children.length >= ROWS
        ? options.indexOf(value) >= ROWS
          ? options.indexOf(value) * OPTION_HEIGHT - OPTION_HEIGHT * 5
          : 0
        : 0
      : 0;

  return Array.isArray(children) ? (
    <List
      height={children.length >= ROWS ? OPTION_HEIGHT * ROWS : children.length * OPTION_HEIGHT}
      itemCount={children.length}
      itemSize={OPTION_HEIGHT}
      initialScrollOffset={initialOffset}
    >
      {({ style, index }) => {
        return <div style={style}>{children[index]}</div>;
      }}
    </List>
  ) : (
    <div>{children}</div>
  );
};

const Option = ({ children, isSelected, innerProps, ...props }) => (
  <div
    className={`hover:bg-primaria hover:text-white transition-all p-2 text-sm h-full whitespace-nowrap text-ellipsis overflow-hidden`}
    id={innerProps.id}
    tabIndex={innerProps.tabIndex}
    onClick={innerProps.onClick}
  >
    {children}
  </div>
);

const Input = (props) => {
  const [firstInteraction, setFirstInteraction] = useState(false);
  const [mode, setMode] = useState(false);

  return (
    <components.Input
      inputMode={mode ? "text" : "none"}
      onClick={(e) => {
        if (firstInteraction) {
          setMode(true);
        }

        setFirstInteraction(true);

        e.target.focus();
      }}
      {...props}
    />
  );
};

const Select = React.forwardRef(
  (
    {
      children,
      label,
      labelTooltip,
      name,
      options,
      placeholder,
      required,
      centerBlueText,
      disabled,
      error,
      field,
      isCreatable,
      noMargin,
      onChange,
      touched,
      errors,
      defaultValue,
      setFieldValue,
      isDisabled,
      isRequired,
      loading,
      variation,
      colSpan,
      className,
      filterOption,
      spacingControl,
      leftIcon,
      ...props
    },
    ref,
  ) => {
    const shouldApplyDefaultValue = true;
    const selectRef = useRef();

    const verifyAutoComplete = () => {
      const e = selectRef.current.inputRef;
      const name = selectRef.current.props.name;

      //  PREVENT AUTOCOMPLETE
      if (preventAutoComplete.includes(name) && e != document.activeElement && e?.value) {
        setTimeout(() => {
          e.value = null;
          selectRef.current.setValue(null);
          e.blur();
        }, 100);
      }
    };

    useEffect(() => {
      if (defaultValue && setFieldValue && name) {
        setFieldValue(name, [defaultValue]);
      }
    }, [name, setFieldValue]);
    return (
      <Wrapper
        data-test-id={props["data-test-id"] ? props["data-test-id"] : null}
        isError={errors && touched}
        centerBlueText={centerBlueText}
        className={[
          "select-component-container",
          colSpan ? `col-span-${colSpan}` : "",
          isDisabled == true ? "desabilitar" : "normal",
          errors && touched ? "error" : "",
          variation,
          className,
        ].join(" ")}
      >
        {label && (
          <FormLabel className="field__label">
            <div className={`flex text-[16px] ${isDisabled ? "text-[#C6C6C6] " : ""}`}>
              {label}
              {isRequired && <span className="text-red-500">*</span>}
              {labelTooltip && <div className="ml-2">{labelTooltip}</div>}
              {label == "*Origem (Centro):" && (
                <>
                  <div className="ml-2">
                    <Info text="Lorem Ipsum Dolor" bg="blue" />
                  </div>
                </>
              )}
            </div>
          </FormLabel>
        )}

        <div className="box-select">
          {/* Ícone da esquerda */}
          {leftIcon && <span className="icon-left">{leftIcon}</span>}

          {/* Ícone da direita */}
          <span className="icon-right">
            <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 1.125L4 3.875L1 1.125"
                stroke="#01054C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>

          {isCreatable ? (
            <ReactSelectCreatable
              name={name}
              classNamePrefix="async-select dddd"
              components={{
                MenuList,
                Option,
              }}
              options={options}
              filterOption={filterOption ? filterOption : createFilter({ ignoreAccents: false })}
              defaultValue={shouldApplyDefaultValue ? defaultValue : undefined}
              onChange={onChange}
              onInputChange={verifyAutoComplete}
              {...field}
              {...props}
              placeholder={placeholder || ""}
              isDisabled={isDisabled}
              noOptionsMessage={() => (props.noOptionsMessage ? props.noOptionsMessage : "Nenhuma opção encontrada")}
              styles={customStyles}
              ref={selectRef}
            />
          ) : (
            <div className="flex items-center select-container">
              <div className={`w-[100%] h-[100%] flex items-center ${spacingControl ? "spacing-control" : ""}`}>
                <ReactSelect
                  name={name}
                  components={{
                    Input,
                    MenuList,
                    Option,
                  }}
                  classNamePrefix="async-select"
                  className={`w-[100%] h-[100%] `}
                  filterOption={filterOption ? filterOption : createFilter({ ignoreAccents: false })}
                  options={options}
                  onChange={onChange}
                  onInputChange={verifyAutoComplete}
                  defaultValue={shouldApplyDefaultValue ? defaultValue : undefined}
                  {...field}
                  {...props}
                  placeholder={placeholder || ""}
                  isDisabled={isDisabled}
                  noOptionsMessage={() =>
                    props.noOptionsMessage ? props.noOptionsMessage : "Nenhuma opção encontrada"
                  }
                  styles={customStyles(leftIcon, centerBlueText)}
                  ref={selectRef}
                />
                {loading ? <Spinner size={"xs"} className="absolute left-2" /> : null}
              </div>
            </div>
          )}

          {children}

          {errors && touched && (
            <p
              style={{
                color: "#E53E3E",
                fontSize: "14px",
                marginTop: "5px",
              }}
            >
              {errors}
            </p>
          )}
        </div>
      </Wrapper>
    );
  },
);

Select.propTypes = {
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelTooltip: PropTypes.node,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  centerBlueText: PropTypes.bool,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.shape({ message: PropTypes.string }), PropTypes.bool, PropTypes.string]),
  field: PropTypes.shape({}),
  isCreatable: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  noMargin: PropTypes.bool,
  defaultValue: PropTypes.any,
  spacingControl: PropTypes.bool,
  leftIcon: PropTypes.node,
};

Select.defaultProps = {
  children: null,
  label: "",
  labelTooltip: null,
  name: "",
  options: [],
  placeholder: "",
  required: false,
  disabled: false,
  centerBlueText: false,
  error: false,
  field: {},
  isCreatable: false,
  noOptionsMessage: "",
  noMargin: false,
  defaultValue: undefined,
  spacingControl: null,
  leftIcon: null,
};

export default Select;

const preventAutoComplete = ["cep", "rua", "numero", "bairro", "complemento", "cidadeId", "uf"];
